var map = {
	"./en/amenities.php": "./resources/lang/en/amenities.php",
	"./en/auth.php": "./resources/lang/en/auth.php",
	"./en/designations.php": "./resources/lang/en/designations.php",
	"./en/pagination.php": "./resources/lang/en/pagination.php",
	"./en/passwords.php": "./resources/lang/en/passwords.php",
	"./en/plots.php": "./resources/lang/en/plots.php",
	"./en/pricehubble.php": "./resources/lang/en/pricehubble.php",
	"./en/regulations.php": "./resources/lang/en/regulations.php",
	"./en/rooms.php": "./resources/lang/en/rooms.php",
	"./en/status.php": "./resources/lang/en/status.php",
	"./en/validation.php": "./resources/lang/en/validation.php"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/lang sync recursive \\.(php%7Cjson)$";